import React, { useEffect, useState } from "react";
import "./Annadanam.css";
import Banner from "./banner/Banner";
import Annadanam_Content from "./annadanam_content/Annadanam_Content";
import Common_Back_Header from "../common/common_components/common_back_header/Common_Back_Header";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { AllDonation, getSingleDonation } from "../../features/admin/donation/Slice";
import { IDS } from "../../utils/IDS";
import { decodeId } from "../../utils/common";

const Annadanam = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const donation = useSelector((state) => state.donation.single_donation);

  // console.log({ donation });

  useEffect(() => {
    dispatch(getSingleDonation({ id: decodeId(id) }))
  }, [dispatch])


  return (
    <section className="Annadanam">
      <div className="container">
        <Common_Back_Header backNavigation={-1} />
      </div>
      <Banner backgroundimage={donation?.backgroundimage} />
      <Annadanam_Content currentData={donation} />
    </section>
  );
};

export default Annadanam;
